// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".IrWVG{color:#0a385a;font-size:14px;font-size:1.4rem;height:auto;margin:0;white-space:normal}.IrWVG .btn-inner{-ms-flex-pack:left;justify-content:left}._38Tzn{color:#95a1bd;display:block;font-size:12px;font-size:1.2rem;font-weight:500;line-height:16px;line-height:1.6rem;text-align:left;white-space:nowrap}._7UAfl{color:#6f7ea2;display:-ms-flexbox;display:flex;font-weight:700;margin-top:6px;-ms-flex-align:center;align-items:center}._7UAfl svg{fill:#30a8ff;height:16px;margin-left:12px;width:16px}", ""]);
// Exports
exports.locals = {
	"root": "IrWVG",
	"label": "_38Tzn",
	"enrollCode": "_7UAfl"
};
module.exports = exports;
